import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const SwiftWithdraw = ({ onBack }) => {
   const [screen, setScreen] = useState(1);
   const [isLoading, setIsLoading] = useState(false);
   const [error, setError] = useState(null);
   const [formData, setFormData] = useState({
      methodOfTransfer: "SWIFT", // Valor fijo para este tipo de transferencia
      bankName: "",
      streetAddress: "",
      country: "",
      bankAddress: "", // Campo adicional requerido por la API
      state: "",
      zipCode: "",
      amount: "",
      accountNumber: "",
      accountType: "",
      swiftCodeBic: "", // Importante para transferencias SWIFT
      routingNumber: "",
      fedwireNumbe: "" // Se mantiene con el mismo nombre para compatibilidad
   });

   const [orderDetails, setOrderDetails] = useState({
      amount: 0,
      fee: 0,
      total: 0,
      bankName: ""
   });

   // Manejar los cambios en los campos del formulario
   const handleInputChange = (e) => {
      const { name, value } = e.target;

      // Para el campo de monto, validar que sea un número
      if (name === 'amount') {
         // Permitir solo números y un punto decimal
         const formattedValue = value.replace(/[^0-9.]/g, '');
         // Evitar múltiples puntos decimales
         const parts = formattedValue.split('.');
         const formatted = parts[0] + (parts.length > 1 ? '.' + parts[1] : '');

         setFormData(prev => ({ ...prev, [name]: formatted }));
      } else {
         setFormData(prev => ({ ...prev, [name]: value }));
      }
   };

   // Validar el formulario para habilitar/deshabilitar el botón continue
   const isFormValid = () => {
      const requiredFields = [
         'bankName', 'streetAddress', 'country', 'bankAddress',
         'state', 'zipCode', 'amount', 'accountNumber', 'swiftCodeBic'
      ];

      return requiredFields.every(field => formData[field].trim() !== '') &&
         parseFloat(formData.amount) > 0;
   };

   const handleContinue = async () => {
      try {
         setIsLoading(true);
         setError(null);

         const jwt = localStorage.getItem('jwt');
         if (!jwt) {
            throw new Error('No authentication token found');
         }

         // Convertir el monto a número
         const dataToSend = {
            ...formData,
            amount: parseFloat(formData.amount)
         };

         // Enviar los datos a la API
         const response = await fetch('https://pt-api.digit-a.net/api/withdraw/bank-transfer', {
            method: 'POST',
            headers: {
               'Authorization': `Bearer ${jwt}`,
               'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
         });

         if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error processing your withdrawal request');
         }

         const data = await response.json();

         // Calcular el fee (1.2% del monto o según tu lógica de negocio)
         const amount = parseFloat(formData.amount);
         const fee = amount * 0.012; // 1.2% fee
         const total = amount + fee;

         setOrderDetails({
            amount: amount.toFixed(2),
            fee: fee.toFixed(2),
            total: total.toFixed(2),
            bankName: formData.bankName
         });

         // Cambiar a la pantalla de confirmación
         setScreen(2);
      } catch (err) {
         console.error('Error submitting withdrawal:', err);
         setError(err.message);
      } finally {
         setIsLoading(false);
      }
   };

   return (
      <div className="swift-withdraw-container">
         {screen === 1 ? (
            <>
               <h3 className="ppt_form_title mb-3 text-center">SWIFT transfer</h3>
               <small className="d-block col-lg-10 mx-lg-auto text-center mb-4">
                  <strong className="text-danger">
                     <img
                        src={process.env.PUBLIC_URL + "/assets/img/icon_warning_red.svg"}
                        alt=""
                        style={{ width: '14px', transform: 'translateY(-1px)' }}
                     /> Warning:
                  </strong> Only transfer funds to accounts in your name. Transfers to mismatched accounts will be rejected and may incur penalty fees.
               </small>

               {error && (
                  <div className="alert alert-danger text-center mb-4">
                     {error}
                  </div>
               )}

               <div className="ppt_deposit_item p-0" style={{ backgroundColor: 'transparent' }}>
                  <div className="row gap-3 m-0">
                     {/* Información bancaria */}
                     <div className="ppt_input_style col-12 px-0">
                        <label>Account Number *</label>
                        <div>
                           <input
                              type="text"
                              name="accountNumber"
                              className="form-control"
                              value={formData.accountNumber}
                              onChange={handleInputChange}
                           />
                        </div>
                     </div>

                     <div className="ppt_input_style col-12 px-0">
                        <label>SWIFT/BIC Code *</label>
                        <div>
                           <input
                              type="text"
                              name="swiftCodeBic"
                              className="form-control"
                              value={formData.swiftCodeBic}
                              onChange={handleInputChange}
                           />
                        </div>
                     </div>


                     <div className="ppt_input_style col-12 px-0">
                        <label>Bank Name *</label>
                        <div>
                           <input
                              type="text"
                              name="bankName"
                              className="form-control"
                              value={formData.bankName}
                              onChange={handleInputChange}
                           />
                        </div>
                     </div>

                     <div className="ppt_input_style col-12 px-0">
                        <label>Bank Address *</label>
                        <div>
                           <input
                              type="text"
                              name="bankAddress"
                              className="form-control"
                              value={formData.bankAddress}
                              onChange={handleInputChange}
                              placeholder="Bank's street address"
                           />
                        </div>
                     </div>

                     <div className="ppt_input_style col-12 px-0">
                        <label>Your Street Address *</label>
                        <div>
                           <input
                              type="text"
                              name="streetAddress"
                              className="form-control"
                              value={formData.streetAddress}
                              onChange={handleInputChange}
                           />
                        </div>
                     </div>

                     <div className="ppt_input_style col-12 px-0">
                        <label>Country *</label>
                        <div>
                           <input
                              type="text"
                              name="country"
                              className="form-control"
                              value={formData.country}
                              onChange={handleInputChange}
                           />
                        </div>
                     </div>

                     <div className="row m-0 p-0">
                        <div className="ppt_input_style col-6 ps-0 pe-1">
                           <label>State *</label>
                           <div>
                              <input
                                 type="text"
                                 name="state"
                                 className="form-control"
                                 value={formData.state}
                                 onChange={handleInputChange}
                              />
                           </div>
                        </div>

                        <div className="ppt_input_style col-6 pe-0 ps-1">
                           <label>Zip Code *</label>
                           <div>
                              <input
                                 type="text"
                                 name="zipCode"
                                 className="form-control"
                                 value={formData.zipCode}
                                 onChange={handleInputChange}
                              />
                           </div>
                        </div>
                     </div>

                     <div className="ppt_input_style col-12 px-0">
                        <label>Amount * ($)</label>
                        <div className="position-relative">
                           {/* <span className="position-absolute" style={{ left: "15px", top: "50%", transform: "translateY(-50%)" }}>$</span> */}
                           <input
                              type="text"
                              name="amount"
                              className="form-control"
                              style={{ paddingLeft: "25px" }}
                              value={formData.amount}
                              onChange={handleInputChange}
                              placeholder="0.00"
                           />
                        </div>
                     </div>

                     <button
                        className="ppt_btn_primary alt mt-3 py-3"
                        style={{ width: '100%', fontSize: '13px', padding: '10px 16px' }}
                        onClick={handleContinue}
                        disabled={isLoading || !isFormValid()}
                     >
                        {isLoading ? 'Processing...' : 'Continue'}
                     </button>
                  </div>
               </div>
            </>
         ) : (
            <>
               <div className='ppt_deposit_item text-center'>
                  <img
                     src={process.env.PUBLIC_URL + '/assets/img/icon_check.svg'}
                     alt=""
                     style={{ width: '100px' }}
                     className="d-block mb-2 mx-auto"
                  />
                  <p className="col-lg-10 mx-lg-auto mb-2">
                     <strong className='d-block mb-2'>Order confirmed!</strong>
                     Your withdrawal request has been submitted successfully. Please allow 3-5 business days for the funds to be transferred to your account.
                  </p>
                  <div className='ppt_deposit_item gap-1 py-3' style={{ backgroundColor: '#E0E0E0' }}>
                     <strong className='d-block'>Order details</strong>
                     <small>
                        <strong>Amount:</strong> ${orderDetails.amount}<br />
                        <strong>Fee:</strong> ${orderDetails.fee}<br />
                        <strong>Total:</strong> ${orderDetails.total}<br />
                        <strong>Bank Name:</strong> {orderDetails.bankName}<br />
                        <strong>Withdrawal method:</strong> SWIFT<br />
                     </small>
                  </div>
                  <div className="d-flex justify-content-center gap-3 pt-2">
                     <small><strong>For any inquiry on your order's status please contact sales at <NavLink className='t-anchor' to='tel:+18242585211'><u>+1 824 258 5211</u></NavLink> or use the <NavLink className='t-anchor' to=''><u>chat bot</u></NavLink>.</strong></small>
                  </div>
               </div>
            </>
         )}
      </div>
   );
};

export default SwiftWithdraw;